import React, { forwardRef, useRef, useState, useMemo } from "react";
import { Tabs } from "antd";

import DelinquencyIndex from "@/views/Dashboard/Delinquency";
import CollectionIndex from "@/views/Dashboard/Collection";
const TabsIndex = forwardRef((props, ref) => {
  const [tabsKey, setTabsKey] = useState("1");
  const [mountedTabs, setMountedTabs] = useState(new Set(["1"]));

  const delinquencyRef = useRef(null);
  const collectionRef = useRef(null);
  const items = useMemo(() => [
    {
      key: "1",
      label: "Delinquency",
      children: <DelinquencyIndex ref={delinquencyRef} />,
    },
    {
      key: "2",
      label: "Collection",
      children: <CollectionIndex ref={collectionRef} />,
    },
  ], []);

  const handleChange = (key) => {
    setTabsKey(key);
    setMountedTabs(prev => new Set(prev).add(key));
      switch(key) {
        case "1":
          delinquencyRef.current?.refresh?.();
          break;
        case "2":
          collectionRef.current?.refresh?.();
          break;
         default:
          break;
      }
  };

  return (
    <div>
      <Tabs 
        activeKey={tabsKey} 
        items={items} 
        onChange={handleChange}
        destroyInactiveTabPane={false}
      />
    </div>
  );
});

export default TabsIndex;